import { camelCaseToSpacedString } from '../../../../../utils/generalHelpers';
import { ExamHistory } from '../../../../../store/workspace/types';
import Button from '../../../../../components/Button';
import { useNavigate } from 'react-router-dom';
import styles from './style.module.scss';

/** Statuses the applicant can pick up where they left off, and where that happens. */
const resumableExams: Record<string, { path: string; cta: string }> = {
    recruitingInterviewRunning: { path: '/examination/interview', cta: 'Continue interview' },
    multipleChoiceExamRunning: { path: '/examination/multipleChoice', cta: 'Continue exam' },
    codingExamRunning: { path: '/examination/coding', cta: 'Continue exam' },
};

interface Props {
    info: ExamHistory;
};

/** One row of the job applications list: what was applied to, when, and how far it got. */
function AppliedJobCard(props: Props) {
    const { info } = props;
    const navigate = useNavigate();
    const resumable = resumableExams[info.status];
    const [year, month, day] = info.lastModified.slice(0, 10).split('-');

    const resume = () => {
        const isCodingExam = info.status === 'codingExamRunning';

        navigate(resumable.path, {
            state: {
                jobId: info.id,
                action: 'resume',
                translateLanguages: info.translateLanguages,
                examId: isCodingExam ? info.codingExamId : info.multipleChoiceExamId,
                ...(isCodingExam && { langs: [info.selectedLanguage], jobTitle: info.title }),
            },
        });
    };

    return (
        <div className={styles.wrapper}>
            <span className={styles.job_title}>{info.title}</span>
            <span className={styles.date}>{`${month}/${day}/${year}`}</span>
            <span className={styles.status}>
                {camelCaseToSpacedString(info.status)}
                {info.status === 'finalResult' && info.finalize && <b> ({camelCaseToSpacedString(info.finalize)})</b>}
            </span>

            {resumable && <Button
                type='Outline-Error'
                onClick={resume}
                text={resumable.cta}
                className={styles.resume_btn}
            />}
        </div>
    )
};

export default AppliedJobCard;
